import React from 'react';
import { Target, Eye, Award, Handshake } from 'lucide-react';
import { aboutContent } from '../../data/mock';

const iconMap = {
  'Engineering Excellence': Award,
  'Transparency': Eye,
  'Ownership': Target,
  'Long-term Partnership': Handshake
};

export const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#f26522] font-semibold text-sm tracking-wider uppercase">
            {aboutContent.title}
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-[#1e3a5f] leading-tight">
            {aboutContent.subtitle}
          </h2>
          <p className="mt-6 text-lg text-gray-600 leading-relaxed">
            {aboutContent.description}
          </p>
        </div>

        {/* Mission & Vision */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="p-8 rounded-2xl bg-[#1e3a5f] text-white">
            <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center mb-6">
              <Target className="w-6 h-6 text-[#f26522]" />
            </div>
            <h3 className="text-xl font-semibold mb-3">Our Mission</h3>
            <p className="text-white/80 leading-relaxed">
              {aboutContent.mission}
            </p>
          </div>

          <div className="p-8 rounded-2xl bg-gradient-to-br from-[#f26522] to-[#d95a1b] text-white">
            <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center mb-6">
              <Eye className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-xl font-semibold mb-3">Our Vision</h3>
            <p className="text-white/90 leading-relaxed">
              {aboutContent.vision}
            </p>
          </div>
        </div>

        {/* Core Values */}
        <div className="text-center mb-10">
          <h3 className="text-2xl font-bold text-[#1e3a5f]">Our Core Values</h3>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {aboutContent.values.map((value, i) => {
            const Icon = iconMap[value.title] || Award;
            return (
              <div
                key={i}
                className="group p-6 rounded-xl bg-gray-50 hover:bg-white hover:shadow-xl border border-transparent hover:border-[#f26522]/20 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-lg bg-[#1e3a5f]/10 flex items-center justify-center mb-4 group-hover:bg-[#f26522] transition-colors duration-300">
                  <Icon className="w-6 h-6 text-[#1e3a5f] group-hover:text-white transition-colors" />
                </div>
                <h4 className="font-semibold text-[#1e3a5f] mb-2">{value.title}</h4>
                <p className="text-sm text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <button
            onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center text-[#f26522] font-medium hover:text-[#d95a1b] transition-colors"
          >
            Start a Conversation
            <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};
